import React from "react";
import InvoiceManagement from "./InvoiceManagement";

export default function OfferManagement() {
    return <InvoiceManagement mode="offer" />;
}
